export default "{\n    \"emptyStateLabel\": \"No Results Found\",\n    \"scrollLabel\": \"scroll\"\n}\n"